import { orderBy } from "lodash-es";
import { isNaN } from "lodash-es";
import { Pagina, BuildPagina } from "./pagina";

export function Paginar(lista, pagina = 0, tamanho = 10) {
  const inicio = tamanho * pagina;
  const content = lista.slice(inicio, inicio + tamanho);
  const totalElements = lista.length;

  let totalPages = parseInt(totalElements / tamanho);
  totalPages += totalElements % tamanho > 0 ? 1 : 0;

  return new Pagina(pagina, content, content.length, totalElements, totalPages);
}

export function OrdenarPagina(lista, campo, ordem, pagina = 0) {
  const listaOrdenada =
    ordem != null ? orderBy(lista, [campo], [ordem.toLowerCase()]) : lista;

  return Paginar(listaOrdenada, pagina);
}

export function NovaPagina(novaPagina = {}, paginaAntiga) {
  if (paginaAntiga) {
    novaPagina = {
      ...paginaAntiga,
      ...novaPagina
    };
  }

  if (novaPagina.number > 0 && novaPagina.numberOfElements === 0) {
    novaPagina.totalPages += 1;
  }

  return BuildPagina(novaPagina);
}

export function NovaPaginaQuery(query) {
  const paginaInicial = {};

  if (query) {
    if (query.pagina && !isNaN(+query.pagina)) {
      paginaInicial.number = +query.pagina;
    }
    if (query.ordem) {
      paginaInicial.sort = query.ordem;
    }
  }

  return BuildPagina(paginaInicial);
}
